import type { AgentApiJobSourcesItem } from '@/types/serializers';
import clsx from 'clsx';
import { useNavigate } from '@tanstack/react-router';
import { formatRelativeDate } from '@/utils/formatRelativeDate';
import LinkedAccountsStatusChip from './LinkedAccountsStatusChip';

type Props = {
  jobSources: AgentApiJobSourcesItem[];
};

export default function LinkedAccountsDatabaseList({ jobSources }: Props) {
  const navigate = useNavigate();

  const handleRowClick = (jobSource: AgentApiJobSourcesItem) => {
    navigate({
      to: '/agent/linked_accounts/$id',
      params: { id: String(jobSource.id) },
      search: { from: 'shared' },
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between rounded-sm bg-gray-100 shadow-[0px_0px_2px_0px_rgba(0,0,0,0.2)]">
        <div className="flex h-[36px] w-full items-center justify-between px-6 py-[6px]">
          <div className="w-[120px] text-sm font-bold text-main">取り込み状況</div>
          <div className="flex-1 text-sm font-bold text-main">タイトル</div>
          <div className="w-[150px] text-sm font-bold text-main">最終同期</div>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        {jobSources.map((jobSource) => {
          const isMuted = jobSource.status === 'deleting';

          return (
            <button
              key={jobSource.id}
              type="button"
              className={clsx(
                'flex h-[80px] items-center justify-between rounded-sm px-6 shadow-[0px_0px_6px_0px_rgba(0,0,0,0.2)]',
                isMuted ? 'bg-[#f6f6f6]' : 'bg-white'
              )}
              onClick={() => handleRowClick(jobSource)}
            >
              <div className="flex w-[120px] items-center">
                <LinkedAccountsStatusChip
                  status={jobSource.status}
                  label={jobSource.status_display_name}
                />
              </div>
              <div
                className="flex min-w-0 flex-1 items-center truncate text-base leading-normal font-bold text-main"
                title={jobSource.title}
              >
                {jobSource.title}
              </div>
              <div className="w-[150px] text-left text-base text-main">
                {jobSource.last_crawled_at
                  ? formatRelativeDate(jobSource.last_crawled_at)
                  : '未同期'}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
